module.exports = {
	"data": {
		"postBySlug": {
			"html": "<h2 id=\"import-the-records-to-the-caaml_region-table\"><a href=\"#import-the-records-to-the-caaml_region-table\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Import the records to the caaml_Region table</h2>\n<p>Given that the schema for a region is defined with a polygon and its center point we are going to use the power of PostGIS spatial functions to create it.</p>\n<p>The query to populate the table for the Italian regions from Aineva is the following:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-sql\"><code><span class=\"token keyword\">INSERT</span> <span class=\"token keyword\">into</span> <span class=\"token keyword\">public</span><span class=\"token punctuation\">.</span><span class=\"token string\">\"caaml_Region\"</span><span class=\"token punctuation\">(</span>fid<span class=\"token punctuation\">,</span> <span class=\"token string\">\"name\"</span><span class=\"token punctuation\">,</span> <span class=\"token string\">\"ID\"</span><span class=\"token punctuation\">,</span> outline<span class=\"token punctuation\">,</span> center_point<span class=\"token punctuation\">,</span> <span class=\"token string\">\"description\"</span><span class=\"token punctuation\">)</span>\n<span class=\"token keyword\">SELECT</span> id<span class=\"token punctuation\">,</span> nome<span class=\"token punctuation\">,</span> mnz<span class=\"token punctuation\">,</span> shape<span class=\"token punctuation\">,</span> ST_centroid<span class=\"token punctuation\">(</span>shape<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> nome <span class=\"token keyword\">from</span> <span class=\"token keyword\">public</span><span class=\"token punctuation\">.</span>mnz\n<span class=\"token comment\" spellcheck=\"true\"># update region_subtype</span>\n<span class=\"token keyword\">UPDATE</span> <span class=\"token keyword\">public</span><span class=\"token punctuation\">.</span><span class=\"token string\">\"caaml_Region\"</span> <span class=\"token keyword\">SET</span> region_subtype <span class=\"token operator\">=</span> <span class=\"token string\">'ForecastRegion'</span>\n</code></pre>\n      </div>\n<p>We have also updated the field region_subtype with the value <code>ForecastRegion</code> which seems to be the default used from EAWS.</p>\n<h2 id=\"visualize-the-resultset-from-pgadmin4\"><a href=\"#visualize-the-resultset-from-pgadmin4\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Visualize the resultset from PGAdmin4</h2>\n<p>The tool PGAdmin4 has embedded a geometry visualizer which can be used to have a quick preview of the layer on a map.</p>\n<p>Let's run the trivial query for the whole</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-sql\"><code><span class=\"token keyword\">select</span> <span class=\"token operator\">*</span> <span class=\"token keyword\">from</span> <span class=\"token keyword\">public</span><span class=\"token punctuation\">.</span><span class=\"token string\">\"caaml_Region\"</span>\n</code></pre>\n      </div>\n<p>and then click on the eye icon of both the geometry columns</p>\n<h2 id=\"outline\"><a href=\"#outline\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>outline</h2>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 50.234375%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACB0lEQVQoz32S227TQBRF8708tElAdRshASpf00pcBIIWVY0oApSkoW0cuYYkvntsj+34knuaZHM8Qa2EEA9LMxqP1tnnjEuPdnaxU3uGJ9IB9vcPUKvVING6tyehUn2M3XKZqKBcKaiKfZXOJUm65/nTFzg8fCn2pdlsBt/3BdPpFGmaotHp4fzyFvX2T5x+u8GnhoLT7128//KwP2sqgvMW3btU8fmqhwuitNlsEMYBHMfBer3GYrFA3+BoKzauujYaXV1c7pgxZCv5L11CCP3YE8K7uzvM53NMJhOx/k1RbLlc/vNbQdGhEPI4g+d5QhTlY7R+GRjoJurXfWimhTNFx0dKqjEfSZIgobFkeQ7OAwQ+g2db4J4L17G3wuFoBtM0hVT3QzQHNkyLhCQKmIUfmoV3NwP4PBQpR6MRchImcYTYd0loIHJdRB7bCqfzBUKqXLTjpiO8kjUcdzTUVR0yJf2qalCVPuIwQpZlGI/H4vHydAhOBWPPAXctIRfC1WoFnj4Ij2QdRyR8S1zIfTiug2HAwP0AjDEh5Zwji2IMvSKZg4R7iHxnKyzaYH9+m3sh8YZQdQNp6AlCuqObDDrLkKUZhjTDmIScZscdC5FDCYvoEVXSjQEWlNBLcpyoNDPFwPG1hhN5gIg51A5D+zbAhxbH6yaD1jNFOtfQENCj2LoOpWfhNyNIxZiElaMmAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"outline region\"\n        title=\"\"\n        src=\"/static/e0be8f55958a7afc35a0771df7f17acd-44d6a.png\"\n        srcset=\"/static/e0be8f55958a7afc35a0771df7f17acd-f4799.png 173w,\n/static/e0be8f55958a7afc35a0771df7f17acd-b3b1d.png 345w,\n/static/e0be8f55958a7afc35a0771df7f17acd-44d6a.png 690w,\n/static/e0be8f55958a7afc35a0771df7f17acd-bc0f7.png 1035w,\n/static/e0be8f55958a7afc35a0771df7f17acd-b50e5.png 1380w,\n/static/e0be8f55958a7afc35a0771df7f17acd-0ed32.png 2070w,\n/static/e0be8f55958a7afc35a0771df7f17acd-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<h2 id=\"center_point\"><a href=\"#center_point\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>center_point</h2>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 50.31250000000001%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACE0lEQVQoz32RSW8TQRCF83c5kNgBbGyQiORfA0EEcQAThUQhkRVkwOt4Hc/as49nxh7vtvyobiMuIA5PXequ+upV9dGjxyc4fvEKT/MFFAoFFItF5J4X8CyXQ/b0CU4yGRxnsshksxSfkrLiPp/PI0c5XGcvz1AqlcTd0Xq9huu6cBwHi8UCk8kED80hrqtdXH/vo1xpovwg4WOlhQ9f6xR38KnSxuU3idTBFeVdVXu4+TnAzY8Bjvb7PYLIg2VZ4DFvoOg+6l2GhsRQlVTcN2RIZowuS/4vKzkA3bELxhi22y1WqxVmsxmWy+Vf4s02m43I+dc7n1AA/fFEjDyfz5GkM/RlFbd1GX1Fw21XQ5lcXrYUeEEIPxwjjGIkSQLfc+BZDJ7N4DsWbGYegFG6hK7rAupQke06+CIRwDHR0Qy8q8kYDRWkaSqm4DDucuxTvqEipHWFtoWI6gRwsVojiGMxjp2kOG8q+EyuaiMN9z0Vg74Km9zyD+PAmHL5WgKXQA5DQI3HdHrmb4e73Q5+cgBaBHxNwAvSXVMG4519Cz4le56HKIrEOZ1OhSMOislpYJvUwD4A+bJtxxVL5cA3LRVvCViTNSSBI+SbDMzyMDRCMfIsnRLMpnsDPjMQ0rumKQdgOl9C1TWs1ts/wPOGgvf1EXzLROTZ9FEO2j0Ddy2GdldFTG6YMkJA77aqQlF0XFDNL03NxxYbguXGAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"centerpoint region\"\n        title=\"\"\n        src=\"/static/1538be11dcfa637c77e40cc5af294fd8-44d6a.png\"\n        srcset=\"/static/1538be11dcfa637c77e40cc5af294fd8-f4799.png 173w,\n/static/1538be11dcfa637c77e40cc5af294fd8-b3b1d.png 345w,\n/static/1538be11dcfa637c77e40cc5af294fd8-44d6a.png 690w,\n/static/1538be11dcfa637c77e40cc5af294fd8-bc0f7.png 1035w,\n/static/1538be11dcfa637c77e40cc5af294fd8-b50e5.png 1380w,\n/static/1538be11dcfa637c77e40cc5af294fd8-0ed32.png 2070w,\n/static/1538be11dcfa637c77e40cc5af294fd8-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>",
			"timeToRead": 1,
			"excerpt": "Import the records to the caaml_Region table Given that the schema for a region is defined with a polygon and its center point we are going...",
			"frontmatter": {
				"title": "Populate Region",
				"cover": null,
				"date": null,
				"category": null,
				"tags": null
			}
		},
		"tableOfContents": {
			"chapters": [
				{
					"title": "1. Introduction",
					"entries": null,
					"chapters": [
						{
							"title": "1.1 OGC Standards",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_ogc.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-ogc"
											},
											"frontmatter": {
												"title": "Introduction to OGC"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "1.1.1 Web Mapping Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wms"
													},
													"frontmatter": {
														"title": "Introduction to WMS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wms-examples"
													},
													"frontmatter": {
														"title": "WMS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.2 Web Feature Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wfs"
													},
													"frontmatter": {
														"title": "Introduction to WFS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wfs-examples"
													},
													"frontmatter": {
														"title": "WFS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.3 Web Coverage Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wcs"
													},
													"frontmatter": {
														"title": "Introduction to WCS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wcs-examples"
													},
													"frontmatter": {
														"title": "WCS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.4 Web Processing Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wps"
													},
													"frontmatter": {
														"title": "Introduction to WPS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wps-examples"
													},
													"frontmatter": {
														"title": "WPS Examples"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "1.2 CAAML",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_caaml.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-caaml"
											},
											"frontmatter": {
												"title": "Introduction to CAAML"
											}
										}
									}
								}
							],
							"chapters": null
						},
						{
							"title": "1.3 INSPIRE",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_inspire.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-inspire"
											},
											"frontmatter": {
												"title": "Introduction to INSPIRE"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "2. Standards in action",
					"entries": null,
					"chapters": [
						{
							"title": "2.1 Prepare data and toolkit",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_data_tools.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/data-and-geospatial-tools"
											},
											"frontmatter": {
												"title": "Data and geospatial tools"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/bootstrap_servers.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/start-the-environment"
											},
											"frontmatter": {
												"title": "Start the environment"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "2.1.1 Manage the data",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/load-data"
													},
													"frontmatter": {
														"title": "Load Data"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/clean_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/clean-data"
													},
													"frontmatter": {
														"title": "Clean Data"
													}
												}
											}
										}
									]
								},
								{
									"title": "2.1.2 Design the CAAML schema",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/er_design.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/caaml-model-design"
													},
													"frontmatter": {
														"title": "CAAML model design"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/populate_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/populate-region"
													},
													"frontmatter": {
														"title": "Populate Region"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "2.2 Build CAAML with GeoAvalanche",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/caaml_hale.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/configure-the-application-schema-for-caaml"
											},
											"frontmatter": {
												"title": "Configure the application schema for CAAML"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_configuration.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/push-the-configuration-to-geo-avalanche"
											},
											"frontmatter": {
												"title": "Push the configuration to GeoAvalanche"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/query_data.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/query-our-region-features"
											},
											"frontmatter": {
												"title": "Query our Region features"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "3. Main Chapter",
					"entries": [
						{
							"entry": {
								"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/lesson_six.md absPath of file",
								"childMarkdownRemark": {
									"fields": {
										"slug": "/lesson-six"
									},
									"frontmatter": {
										"title": "Lesson Six"
									}
								}
							}
						}
					],
					"chapters": null
				}
			]
		}
	},
	"pathContext": {
		"slug": "/populate-region"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/populate-region.json
// module id = 421
// module chunks = 123203233883693